import { createEntityTagProviders } from '@/shared/redux/api/assets/assets-api.utils';

import { api } from '../../_generated/api/assets-api.generated';

type TagType = 'Workstation';

const workstationTags = createEntityTagProviders<TagType>(
  'Workstation' as const,
  'workstationId',
  'groupId',
);

export const workstationsApi = api.enhanceEndpoints({
  addTagTypes: ['Workstation', 'Groups', 'Connection', 'GlueLog'],
  endpoints: {
    CreateWorkstation: {
      invalidatesTags: (result, _, __) => {
        return [
          { type: 'Workstation' as const, id: 'LIST' },
          { type: 'Groups' as const, id: result?.createWorkstation.groupId },
        ];
      },
    },
    DeleteWorkstation: {
      invalidatesTags: (result) => {
        return [
          { type: 'Workstation' as const, id: 'LIST' },
          { type: 'Groups' as const, id: result?.deleteWorkstation.groupId },
        ];
      },
    },
    ReadAllWorkstations: {
      providesTags: workstationTags.listTags,
    },
    UpdateWorkstation: {
      invalidatesTags: (result, _, arg) => [
        { type: 'Workstation' as const, id: arg.workstationId },
        { type: 'Workstation' as const, id: 'LIST' },
        { type: 'Groups' as const, id: result?.updateWorkstation.groupId },
      ],
    },
    ReadWorkstation: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Workstation' as const, id: arg.workstationId }];
      },
    },
    ReadWorkstationHealthStatus: {
      providesTags: (_, __, arg) => {
        return [{ type: 'Workstation' as const, id: arg.workstationId }];
      },
    },
    ReadWorkstationConnections: {
      providesTags: () => {
        return [{ type: 'Connection' as const, id: 'LIST' }];
      },
    },
    ReadWorkstationGlueLogEntries: {
      providesTags: (_, __, arg) => {
        return [{ type: 'GlueLog' as const, id: arg.workstationId }];
      },
    },
    CreateWorkstationConnection: {
      invalidatesTags: () => [{ type: 'Connection' as const, id: 'LIST' }],
    },
    DeleteWorkstationConnection: {
      invalidatesTags: () => [{ type: 'Connection' as const, id: 'LIST' }],
    },
  },
});

export const {
  useCreateWorkstationMutation,
  useDeleteWorkstationMutation,
  useReadAllWorkstationsQuery,
  useReadWorkstationHealthStatusQuery,
  useReadWorkstationQuery,
  useUpdateWorkstationMutation,
  useReadWorkstationConnectionsQuery,
  useCreateWorkstationConnectionMutation,
  useDeleteWorkstationConnectionMutation,
  useReadWorkstationGlueLogEntriesQuery,
  useLazyReadWorkstationGlueLogEntriesQuery,
} = workstationsApi;
